var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "new_top" },
        [_c("header2"), _vm._v(" "), _c("navigation")],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "new_content" }, [
        _c("div", { staticClass: "new_jpkc_erji" }, [
          _c("div", { staticClass: "new_yxdt" }, [
            _c("div", { staticClass: "new_yxdt_tab" }, [
              _c("ul", { attrs: { id: "new_yxdt_tab_all" } }, [
                _c("li", [
                  _c(
                    "a",
                    {
                      class: { new_yxdt_tab_sel: _vm.switchTag === 6 },
                      attrs: { href: "javascript:;" },
                      on: {
                        click: function($event) {
                          return _vm.init(6)
                        }
                      }
                    },
                    [_vm._v("前沿动态")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      class: { new_yxdt_tab_sel: _vm.switchTag === 7 },
                      attrs: { href: "javascript:;" },
                      on: {
                        click: function($event) {
                          return _vm.init(7)
                        }
                      }
                    },
                    [_vm._v("医事经纬")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      class: { new_yxdt_tab_sel: _vm.switchTag === 8 },
                      attrs: { href: "javascript:;" },
                      on: {
                        click: function($event) {
                          return _vm.init(8)
                        }
                      }
                    },
                    [_vm._v("病例讨论")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      class: { new_yxdt_tab_sel: _vm.switchTag === 9 },
                      attrs: { href: "javascript:;" },
                      on: {
                        click: function($event) {
                          return _vm.init(9)
                        }
                      }
                    },
                    [_vm._v("行业信息")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      class: { new_yxdt_tab_sel: _vm.switchTag === 12 },
                      attrs: { href: "javascript:;" },
                      on: {
                        click: function($event) {
                          return _vm.init(12)
                        }
                      }
                    },
                    [_vm._v("学术会议")]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                staticClass: "new_jpkc_list",
                staticStyle: {
                  "padding-left": "15px",
                  "border-left": "1px #ccc solid"
                },
                attrs: { id: "kc6" }
              },
              _vm._l(_vm.newsList, function(item) {
                return _c(
                  "div",
                  { staticClass: "njl1" },
                  [
                    _c(
                      "div",
                      { staticClass: "njl_pic" },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: { path: "/newsInfo", query: { id: item.id } },
                              target: "_blank"
                            }
                          },
                          [_c("img", { attrs: { src: item.image } })]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        staticClass: "njl_text",
                        attrs: {
                          to: { path: "/newsInfo", query: { id: item.id } },
                          target: "_blank"
                        }
                      },
                      [
                        _c("span", { staticClass: "njl_title textover" }, [
                          _vm._v(_vm._s(item.newsTitle))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "njl_intro" }, [
                          _vm._v(_vm._s(item.description))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "njl_speaker" }, [
                          _vm._v(_vm._s(item.publishTime))
                        ])
                      ]
                    )
                  ],
                  1
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "new_num_list", attrs: { id: "coursePageUl6" } },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.pageNum,
                    "page-size": _vm.pageSize,
                    layout: "prev, pager, next, jumper",
                    total: _vm.total
                  },
                  on: {
                    "current-change": _vm.handleCurrentChange,
                    "update:currentPage": function($event) {
                      _vm.pageNum = $event
                    },
                    "update:current-page": function($event) {
                      _vm.pageNum = $event
                    }
                  }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("footer1")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-266a53d9", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-266a53d9","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/MedicalDynamicNewsList.vue
// module id = null
// module chunks = 